import { PageTemplate } from "../../components"
import { useTranslation } from "../../language"
import { DoctorsList } from "./doctorsList";

export const DoctorsPage = () => {
  const translate = useTranslation();

  return (
    <PageTemplate>
      <h2 style={{ textAlign: "center" }}>{translate("DoctorsPage.Heading")}</h2>
      <DoctorsList />
    </PageTemplate>
  )
}